module.exports = __webpack_public_path__ + "img/black.ac33161c.png";